export default {
      id: "checked-usage",
      viewBox: "0 0 14 12",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#checked",
      toString: function () {
        return this.url;
      }
    }